// Browser substitute for ./keepAliveAgent, wired up via the "browser" field
// in this package's package.json. The browser's fetch manages its own
// connections, so no agent is passed and no Node.js builtins are bundled.
export const keepAliveAgent = undefined;
